<section class="cmn-innerpage-wrapper">
  <div class="head">
    <h1>Bedtime Story</h1>
    <div class="head-div">
      <div class="search-wrapper">
        <input
          type="text"
          class="cmn-header-search"
          placeholder="Search Stories"
          (input)="onSearch($event)"
        />
      </div>
      <button
        class="cmn-add-btn"
        *appHasPermission="'ADD_STORY'"
        (click)="newStory()"
      >
        <img src="assets/images/icons/icon-add.svg" alt="Add icon" /> Add Story
      </button>
    </div>
  </div>
  <div *ngIf="!loading" class="itemListWrapper">
    <div class="itemWrapper" *ngFor="let story of storyList">
      <div class="story-img-wrapper">
        <img
          [src]="
            story.thumbURL || '../../../assets/images/placeHolderImage.jpg'
          "
          alt="StoryImage"
          (error)="onImageError($event)"
        />
      </div>
      <h3 class="cmn-list-title">{{ getTranslationName(story) }}</h3>
      <div class="action-Container">
        <div class="action-wrapper">
          <div
            *appHasPermission="'UPDATE_STORY'"
            (click)="openDialog(story)"
            class="iconWrapper" >
            <img src="../../../assets/images/icons/view.svg" alt="" />
          </div>
          <div
            *appHasPermission="'UPDATE_STORY'"
            (click)="onEditStory(story?.id)"
            class="iconWrapper"
          >
            <img src="../../../assets/images/icons/icon-edit.svg" alt="" />
          </div>
          <div
            *appHasPermission="'DELETE_STORY'"
            (click)="deleteStory(story?.id)"
            class="iconWrapper"
          >
            <img src="../../../assets/images/icons/icon-delete.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="noData">
    <app-no-data-component> </app-no-data-component>
  </div>
  <app-content-loader [visible]="loading"></app-content-loader>
</section>
